import React from 'react'
// import { Document, Page, pdfjs } from 'react-pdf'

const PDFView = data => {
  var file = new Blob([data.file], { type: 'application/pdf' })
  var fileURL = URL.createObjectURL(file)
  window.open(fileURL)

  // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  // window.open(renderPdf)
  return (
    <div>
      {/* <Document file={{ url: fileURL }} onLoadError={error => alert(error.message)}>
        <Page pageNumber={1} />
      </Document> */}
    </div>
  )
}

export default PDFView
